var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasErros)?_c('div',[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},_vm._l((_vm.modelstate),function(ms){return _c('div',{key:ms},[_c('span',[_vm._v(" - "+_vm._s(ms[0])+" ")])])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }